import ConfigurationApi from '@/api/configurationApi';
import AppSettingsService from '@/services/appSettingsService';

const tenantName = AppSettingsService.getTenantName();
const bigLogo = AppSettingsService.getBigLogo();
const smallLogo = AppSettingsService.getSmallLogo();

const state = {
  settingsLoading: false,
  tenantName: tenantName || null,
  bigLogo: bigLogo || null,
  smallLogo: smallLogo || null
};

const getters = {
  view: state => {
    const defaultBigLogo = require('@/assets/logo-start.png');
    const defaultSmallLogo = require('@/assets/logo-bar.png');

    if (!state.tenantName) {
      return {
        bigLogo: defaultBigLogo,
        smallLogo: defaultSmallLogo
      };
    }

    return {
      bigLogo: state.bigLogo || defaultBigLogo,
      smallLogo: state.smallLogo || defaultSmallLogo
    };
  }
};

const actions = {
  async loadAppSettings({ commit }, payload) {
    try {
      commit('APP_SETTINGS_LOADING', { loading: true });

      const configurationApi = new ConfigurationApi();

      const bigLogoPromise = configurationApi.getTenantBigLogo(payload.tenantName);
      const smallLogoPromise = configurationApi.getTenantSmallLogo(payload.tenantName);

      const { data: bigLogoData } = await bigLogoPromise;
      const { data: smallLogoData } = await smallLogoPromise;

      commit('APP_SETTINGS', {
        bigLogo: bigLogoData.result,
        smallLogo: smallLogoData.result,
        tenantName: payload.tenantName
      });

      commit('APP_SETTINGS_LOADING', { loading: false });
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  },
  async saveBigLogo({ commit }, payload) {
    try {
      await new ConfigurationApi().setTenantBigLogo(payload.logoUri);

      commit('BIG_LOGO', {
        bigLogo: payload.logo
      });
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  },
  async saveSmallLogo({ commit }, payload) {
    try {
      await new ConfigurationApi().setTenantSmallLogo(payload.logoUri);

      commit('SMALL_LOGO', {
        smallLogo: payload.logo
      });
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  }
};

const mutations = {
  APP_SETTINGS(state, payload) {
    const bigLogo = payload.bigLogo && `${payload.bigLogo.uri}${payload.bigLogo.sasBlobToken}`;
    const smallLogo = payload.smallLogo && `${payload.smallLogo.uri}${payload.smallLogo.sasBlobToken}`;

    AppSettingsService.saveBigLogo(bigLogo);
    AppSettingsService.saveSmallLogo(smallLogo);
    AppSettingsService.saveTenantName(payload.tenantName);

    state.bigLogo = bigLogo;
    state.smallLogo = smallLogo;
    state.tenantName = payload.tenantName;
  },
  APP_SETTINGS_LOADING(state, payload) {
    state.settingsLoading = payload.loading;
  },
  BIG_LOGO(state, payload) {
    const bigLogo = payload.bigLogo && `${payload.bigLogo.uri}${payload.bigLogo.sasBlobToken}`;
    AppSettingsService.saveBigLogo(bigLogo);
    state.bigLogo = bigLogo;
  },
  SMALL_LOGO(state, payload) {
    const smallLogo = payload.smallLogo && `${payload.smallLogo.uri}${payload.smallLogo.sasBlobToken}`;
    AppSettingsService.saveSmallLogo(smallLogo);
    state.smallLogo = smallLogo;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
